<div *ngIf="!cargando && sidebarLinks.length" class="row contenedor">
  <app-sidebar
    [sidebarLinks]="sidebarLinks"
    [selected]="sidebarLinks[0].id"
    class="col-12 col-md-2"
  ></app-sidebar>
  <div class="col contenido">
    <div class="header-container arrgInfo">
      <div class="col-md-8 col-sm-12 height-defined">
        <ul class="d-flex flex-row breadcrumbs">
          <li
            class="breadcrumb-item blue-bold"
            *ngFor="let link of links; first as first"
          >
            {{ link }}
            <label *ngIf="first" class="bread-crumb-symbol"> ></label>
          </li>
        </ul>
        <label-data [label]="subtitle" class="text-small"></label-data>
      </div>
      <div class="search col-md-4 col-sm-12">
        <app-input-search
          [data]="dataTarifa2"
          [inputText]="inputText"
          (result)="onResult($event)"
        ></app-input-search>
      </div>
    </div>
    <div class="table">
      <app-data-table
        [data]="newData"
        [tableHeaders]="headers"
      ></app-data-table>
    </div>
  </div>
</div>
<under-construction
  *ngIf="!cargando && !sidebarLinks.length"
></under-construction>
<div class="loader" *ngIf="cargando">
  <mat-spinner></mat-spinner>
</div>
